type Props = { className?: string };

export default function BrandLogo({ className }: Props) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="sprynai-grad" x1="0" y1="0" x2="32" y2="32">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#b8b8b8" />
        </linearGradient>
      </defs>
      <rect
        x="1"
        y="1"
        width="30"
        height="30"
        rx="9"
        fill="url(#sprynai-grad)"
      />
      <path
        d="M11 20.5C11 22.4 12.6 24 14.5 24h3c1.9 0 3.5-1.6 3.5-3.5S19.4 17 17.5 17h-3c-1.9 0-3.5-1.6-3.5-3.5S12.6 10 14.5 10h6"
        stroke="#000"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
